import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const SHForward = () => (
  <ImageIcon src={Images.Forward} alt="sh-forward-icon/" />
);

export default SHForward;
